import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../../../app/GetProxy";
import { handleResponseCode } from "../../../../app/utilities/helpers";

const proxy = GetProxy();
const cookies = new Cookies();

export const getForcastData = createAsyncThunk(
  "post/getForcastData",
  async () => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/report/api/v1/cloudCostInsightsController/getMonthUsageTrendWithForecast`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": Apitoken,
            USERNAME: User,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getResourceSpend = createAsyncThunk(
  "post/getResourceSpend",
  async () => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/report/api/v1/cloudCostInsightsController/getTotalSpendBreakdownByServiceCategories`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": Apitoken,
            USERNAME: User,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getTop5AccountNameSpent = createAsyncThunk(
  "post/getTop5AccountNameSpent",
  async () => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/report/api/v1/cloudCostInsightsController/getTopFiveHighestSpendingAwsAccounts`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": Apitoken,
            USERNAME: User,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

//cost overview LIST

export const DetailsTablelist = createAsyncThunk(
  "post/DetailsTablelist",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;

      const response = await fetch(
        `${proxy}/report/api/v1/cloudCostInsightsController/getCostOverViewDetailsTableList/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error", error);
      throw error;
    }
  }
);

//cost overview LIST

export const DetailsTableCount = createAsyncThunk(
  "post/DetailsTableCount",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;

      const response = await fetch(
        `${proxy}/api/v1/cloudCostInsightsController/getCostOverViewDetailsTableListCount`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.log("Error", error);
      throw error;
    }
  }
);

//filter
export const getFinancialYearsListAPI = createAsyncThunk(
  "post/getFinancialYearsListAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/report/api/v1/cloudCostInsightsController/getFinancialYearsList`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);

// MTD

export const CurrentMontCostAPI = createAsyncThunk(
  "post/CurrentMontCostAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/report/api/v1/cloudCostInsightsController/getMTDCloudCost`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);

//YTD

export const getYearTillDateGraphAPI = createAsyncThunk(
  "post/getYearTillDateGraphAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/report/api/v1/cloudCostInsightsController/getYTDCloudCost`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);

//monthly variance chart

export const MonthlyCostVarianceAPI = createAsyncThunk(
  "post/MonthlyCostVarianceAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/report/api/v1/cloudCostInsightsController/getMonthCostVarianceGraphData`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);

const initialState = {
  forcastDataLoading: false,
  forcastData: [],
  ResourceSpendLoading: false,
  ResourceSpendData: [],
  Top5SpendLoading: false,
  Top5SpendData: [],
  DetailsTableloading: false,
  DetailsTableData: [],
  DetailsTableCountData: [],
  DetailsTableCountloading: false,
  CurrentMontCostData: [],
  CurrentMontCostLoading: false,
  getYearTillDateGraphData: [],
  getYearTillDateGraphLoading: false,
  CostVarianceData: [],
  CostVarianceLoading: false,
  error: "",
  apiError: false,
  getFinancialYearsData: [],
  getFinancialYearsLoading: false,
};

export const CloudCostsummarySlice = createSlice({
  name: "CloudCostsummarySlice",
  initialState,

  reducers: {
    resetCloudCostsummaryData: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getForcastData.pending, (state, action) => {
        state.cloudConversionLoading = true;
        state.apiError = false;
      })
      .addCase(getForcastData.fulfilled, (state, action) => {
        state.forcastData = action.payload;
        state.forcastDataLoading = false;
        state.apiError = false;
      })
      .addCase(getForcastData.rejected, (state, action) => {
        state.forcastDataLoading = false;
        state.forcastData = [];
        state.error = "Something went wrong";
        state.apiError = true;
      })

      .addCase(getResourceSpend.pending, (state, action) => {
        state.ResourceSpendLoading = true;
        state.apiError = false;
      })
      .addCase(getResourceSpend.fulfilled, (state, action) => {
        state.ResourceSpendData = action.payload;
        state.ResourceSpendLoading = false;
        state.apiError = false;
      })
      .addCase(getResourceSpend.rejected, (state, action) => {
        state.ResourceSpendLoading = false;
        state.ResourceSpendData = [];
        state.error = "Something went wrong";
        state.apiError = true;
      })

      .addCase(getTop5AccountNameSpent.pending, (state, action) => {
        state.Top5SpendLoading = true;
        state.apiError = false;
      })
      .addCase(getTop5AccountNameSpent.fulfilled, (state, action) => {
        state.Top5SpendData = action.payload;
        state.Top5SpendLoading = false;
        state.apiError = false;
      })
      .addCase(getTop5AccountNameSpent.rejected, (state, action) => {
        state.Top5SpendLoading = false;
        state.Top5SpendData = [];
        state.error = "Something went wrong";
        state.apiError = true;
      })

      //cost overview deatils list

      .addCase(DetailsTablelist.pending, (state, action) => {
        state.DetailsTableloading = true;
        state.apiError = false;
      })
      .addCase(DetailsTablelist.fulfilled, (state, action) => {
        state.DetailsTableData = action.payload;
        state.DetailsTableloading = false;
        state.apiError = false;
      })
      .addCase(DetailsTablelist.rejected, (state, action) => {
        state.DetailsTableloading = false;
        state.DetailsTableData = [];
        state.error = "Something went wrong";
        state.apiError = true;
      })

      //cost overview deatils count

      .addCase(DetailsTableCount.pending, (state, action) => {
        state.DetailsTableCountloading = true;
        state.apiError = false;
      })
      .addCase(DetailsTableCount.fulfilled, (state, action) => {
        state.DetailsTableCountData = action.payload;
        state.DetailsTableCountloading = false;
        state.apiError = false;
      })
      .addCase(DetailsTableCount.rejected, (state, action) => {
        state.DetailsTableCountloading = false;
        state.DetailsTableCountData = [];
        state.error = "Something went wrong";
        state.apiError = true;
      })

      //filter

      .addCase(getFinancialYearsListAPI.pending, (state, action) => {
        state.getFinancialYearsLoading = true;
        state.apiError = false;
      })
      .addCase(getFinancialYearsListAPI.fulfilled, (state, action) => {
        state.getFinancialYearsData = action.payload;
        state.getFinancialYearsLoading = false;
        state.apiError = false;
      })
      .addCase(getFinancialYearsListAPI.rejected, (state, action) => {
        state.getFinancialYearsLoading = false;
        state.getFinancialYearsData = [];
        state.error = "Something went wrong";
        state.apiError = true;
      })

      //MTD

      .addCase(CurrentMontCostAPI.pending, (state, action) => {
        state.CurrentMontCostLoading = true;
        state.apiError = false;
      })
      .addCase(CurrentMontCostAPI.fulfilled, (state, action) => {
        state.CurrentMontCostData = action.payload;
        state.CurrentMontCostLoading = false;
        state.apiError = false;
      })
      .addCase(CurrentMontCostAPI.rejected, (state, action) => {
        state.CurrentMontCostLoading = false;
        state.CurrentMontCostData = [];
        state.error = "Something went wrong";
        state.apiError = true;
      })

      //YTD

      .addCase(getYearTillDateGraphAPI.pending, (state, action) => {
        state.getYearTillDateGraphLoading = true;
        state.apiError = false;
      })
      .addCase(getYearTillDateGraphAPI.fulfilled, (state, action) => {
        state.getYearTillDateGraphData = action.payload;
        state.getYearTillDateGraphLoading = false;
        state.apiError = false;
      })
      .addCase(getYearTillDateGraphAPI.rejected, (state, action) => {
        state.getYearTillDateGraphLoading = false;
        state.getYearTillDateGraphData = [];
        state.error = "Something went wrong";
        state.apiError = true;
      })

      //MonthlyCostVarianceAPI

      .addCase(MonthlyCostVarianceAPI.pending, (state, action) => {
        state.CostVarianceLoading = true;
        state.apiError = false;
      })
      .addCase(MonthlyCostVarianceAPI.fulfilled, (state, action) => {
        state.CostVarianceData = action.payload;
        state.CostVarianceLoading = false;
        state.apiError = false;
      })
      .addCase(MonthlyCostVarianceAPI.rejected, (state, action) => {
        state.CostVarianceLoading = false;
        state.CostVarianceData = [];
        state.error = "Something went wrong";
        state.apiError = true;
      });
  },
});

export const { resetCloudCostsummaryData } = CloudCostsummarySlice.actions;
export default CloudCostsummarySlice.reducer;
